module.exports = __webpack_public_path__ + "static/media/PolyDoge.3e2a77b0.png";